import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";
import { store } from "../../utils/store";

export async function getDataAttendance(roleId?: String) {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(urls.DASHBOARDATTENDANCE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDataMyAttendance(roleId?: String) {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(`${urls.DASHBOARDMYATTENDANCE}${roleId}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDataProject(payload:any) {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(
      `${urls.DASHBOARDPROJECT}?start_date=${payload.startDate}&end_date=${payload.endDate}`,callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDataMylead(roleId?: String) {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(urls.DASHBOARDMYLEAD, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDataAllLead(roleId?: any) {
  console.log(roleId,"vnfvdjkbdkjbdsjkdbijdbdkjb")
  try {
    const callParams = await getCallParams("POST",roleId);

    const response = await makeCall(urls.DASHBOARDALLLEADS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getReminder() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETREMINDERALL}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getMyTeam(roleId?: String) {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(`${urls.DASHBOARDMYTEAM}${roleId}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}


export async function getDashboardSourceCount(team_id:any) {
  try {
    const callParams = await getCallParams("GET");

    // const response = await makeCall(urls.GETDAHBOARDSOURCECOUNT, callParams);
    const response = await makeCall(
      `${urls.GETDAHBOARDSOURCECOUNT}?team_id=${team_id || ""}`,callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getDashboardFunnelCount() {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(urls.GETDAHBOARDFUNNELSTAGECOUNT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getDashboardParentStageCount(team_id:any) {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(
      `${urls.GETDAHBOARDPARENTSTAGECOUNT}?team_id=${team_id || ""}`,callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDashboardStageCount() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETDAHBOARDSTAGECOUNT}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDashboardTeamStageCount() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.DASHBOARDTEAMSTAGECOUNT}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDashboardSalesTeamStageCount() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.DASHBOARDSALESTEAMSTAGECOUNT}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDashboardPreSalesStage() {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(urls.DASHBOARDPRESALESSTAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDashboardPreSalesStageCount(team_id:any) {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(
      `${urls.DASHBOARDPRESALESSTAGECOUNT}?team_id=${team_id || ""}`,callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDashboardSalesStageCount(team_id:any) {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(
      `${urls.DASHBOARDSALESSTAGECOUNT}?team_id=${team_id || ""}`,callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDashboardSalesStage() {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(urls.DASHBOARDSALESSTAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getMyDashboardSourceCount() {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(urls.GETMYDASHBOARDSOURCECOUNT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getMyDashboardPreSaleStageCount() {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(urls.GETMYDASHBOARDPRESALESSTAGECOUNT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getMyDashboardSaleStageCount() {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(urls.GETMYDASHBOARDSALESTAGECOUNT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getMyDashboardReminder() {
  try {
    const callParams = await getCallParams("GET");

    const response = await makeCall(urls.GETMYDASHBOARDREMINDER, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getMyPerformance(period: "today" | "month" = "today") {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETMYPERFORMANCE}?period=${period}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getTodaysWork() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETTODAYSWORK, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getSalesTargets(params?: {
  userId?: string;
  period?: "daily" | "monthly";
}) {
  try {
    const callParams = await getCallParams("GET");
    const qs = new URLSearchParams();
    if (params?.userId) qs.set("userId", params.userId);
    if (params?.period) qs.set("period", params.period);
    const q = qs.toString();
    const response = await makeCall(
      `${urls.SALESTARGETS}${q ? `?${q}` : ""}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function saveSalesTarget(payload: {
  userId: string;
  period: "daily" | "monthly";
  callsTarget?: number;
  followUpsTarget?: number;
  closuresTarget?: number;
  year?: number;
  month?: number;
  day?: number;
}) {
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.SALESTARGETS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getSalesTargetProgress(params: {
  userId?: string;
  period?: "today" | "month";
}) {
  try {
    const callParams = await getCallParams("GET");
    const qs = new URLSearchParams();
    if (params?.userId) qs.set("userId", params.userId);
    if (params?.period) qs.set("period", params.period);
    const q = qs.toString();
    const response = await makeCall(
      `${urls.SALESTARGETS}/progress${q ? `?${q}` : ""}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function transferUserLeads(payload: {
  fromUserId: string;
  toUserId: string;
  limit?: number;
}) {
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.TRANSFERUSERLEADS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getNotificationPreferences() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.NOTIFICATIONPREFERENCES, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateNotificationPreferences(prefs: {
  stageChange?: boolean;
  assignment?: boolean;
  reminder?: boolean;
  teamAlert?: boolean;
}) {
  try {
    const callParams = await getCallParams("PUT", prefs);
    const response = await makeCall(urls.NOTIFICATIONPREFERENCES, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function checkLeadDuplicate(params: {
  phone?: string;
  email?: string;
}) {
  try {
    const callParams = await getCallParams("GET");
    const qs = new URLSearchParams();
    if (params.phone) qs.set("phone", params.phone);
    if (params.email) qs.set("email", params.email);
    const response = await makeCall(
      `${urls.CHECKLEADDUPLICATE}?${qs.toString()}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getDashboardV2(params: {
  period?: string;
  from?: string;
  to?: string;
  teamId?: string;
  agentIds?: string;
}) {
  try {
    const callParams = await getCallParams("GET");
    const qs = new URLSearchParams();
    if (params.period) qs.set("period", params.period);
    if (params.from) qs.set("from", params.from);
    if (params.to) qs.set("to", params.to);
    if (params.teamId) qs.set("teamId", params.teamId);
    if (params.agentIds) qs.set("agentIds", params.agentIds);
    const orgId = String(store.getState().auth?.activeOrganizationId || "").trim();
    qs.set(
      "organizationId",
      !orgId || orgId === "all" || orgId === "*" ? "all" : orgId
    );
    const response = await makeCall(
      `${urls.DASHBOARD_V2}?${qs.toString()}`,
      callParams,
      60000
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function nudgeDashboardAgent(userId: string, message?: string) {
  const callParams = await getCallParams("POST", { userId, message });
  return makeCall(`${urls.DASHBOARD_V2}/nudge`, callParams);
}

export async function reviewDashboardCall(id: string) {
  const callParams = await getCallParams("POST", {});
  return makeCall(`${urls.DASHBOARD_V2}/calls/${id}/review`, callParams);
}

export async function dashboardWhatsApp(leadId: string) {
  const callParams = await getCallParams("GET");
  return makeCall(`${urls.DASHBOARD_V2}/whatsapp?leadId=${leadId}`, callParams);
}

export async function recycleLead(payload: {
  leadIds: string | string[];
  stage?: string;
  assignToUserId?: string;
}) {
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.RECYCLELEAD, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}